<template>
  <div class="auth-widget" :class="classes">
    <div class="auth-widget__welcome">
      <span>Здравствуйте,</span>
      <router-link to="/profile" class="auth-widget__name"
        >{{ user.first_name }} {{ user.middle_name }}</router-link
      >
    </div>
    <template v-if="showLinks">
      <AppBtn class="auth-widget__btn" to="/profile" title="Профиль">
        <svg-icon size="28" icon-name="profile"></svg-icon>
      </AppBtn>
      <AppBtn
        v-if="!hasTeam && !$core.breakpoint.smAndDown"
        class="auth-widget__reg"
        color="third"
        to="/profile"
      >
        Создать команду
      </AppBtn>
    </template>
    <AppBtn class="auth-widget__btn" title="Выход" @click="logout">
      <svg-icon size="28" icon-name="exit"></svg-icon>
    </AppBtn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { openModal } from "../user/UserProfileModal";

export default {
  components: {},

  props: {
    hideWelcome: Boolean,
    inDrawer: Boolean
  },

  computed: {
    ...mapGetters("auth", ["user"]),
    showLinks() {
      return this.$route.name !== "profile";
    },
    classes() {
      return {
        "auth-widget_long": !this.showLinks
      };
    },
    hasTeam() {
      return this.user && !!this.user.team_id;
    }
  },

  methods: {
    ...mapActions("auth", ["logout"]),

    async showProfileModal() {
      await openModal(this.user);
    }
  }
};
</script>

<style lang="scss">
$p: ".auth-widget";

.auth-widget {
  position: relative;
  width: 220px;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  text-align: right;
  align-items: center;
  font-size: 16px;

  &__bg {
    border-radius: 4px;
  }

  &__btn {
    width: 40px;
    height: 40px;
    text-transform: uppercase;
    font-size: 15px;
    font-weight: fw(bold);
    flex-shrink: 0;
    padding: 0 5px;
    margin-left: 10px;
  }

  &__name {
    font-size: 20px;
    font-weight: bold;
    @include text-ellipsis();
    width: 100%;
    color: colors(text-2);
  }

  &__welcome {
    width: calc(100% - 105px);
    color: colors(text-2);
  }

  &__reg {
    position: absolute;
    bottom: -80px;
    width: 220px;
    font-size: 18px;
    text-transform: uppercase;
    height: 45px;
  }

  &_long &__welcome {
    width: calc(100% - 50px);
  }
}
</style>
